
import { defineComponent, nextTick, ref } from 'vue';
import { useMainStore } from '@/store/mainStore';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import { CHOOSER_TYPE, MEDIA_TYPES } from '@/types/enums';
import { bmpConvertorToFile } from '@/helpers/bmpConvertor';
import useFlutter from '@/composables/UseFlutter';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  setup(props, context) {
    const mainStore = useMainStore();
    const isOpen = ref(false);
    const fileInput = ref();

    const {
      flutterOpenCamera,
      flutterOpenImagePicker,
      flutterOpenFilePicker,
      flutterAddMedia,
    } = useFlutter();

    function openCamera() {
      flutterOpenCamera();
      nextTick(() => {
        isOpen.value = false;
      });
    }

    function openImagePicker() {
      flutterOpenImagePicker();
      nextTick(() => {
        isOpen.value = false;
      });
    }

    function openFilePicker() {
      flutterOpenFilePicker();
      nextTick(() => {
        isOpen.value = false;
      });
    }

    function setChooserType(type?) {
      const { nativeApp } = window as any;

      if (nativeApp && type) {
        nativeApp.setChooserType(type);
      }
    }

    function hidePopUp() {
      isOpen.value = false;
    }

    function openTakePhoto(chooserType?) {
      if (chooserType) {
        setChooserType(chooserType);
      }
      context.emit('open-take-photo', chooserType);
      hidePopUp();
    }

    function openDriveMedia() {
      context.emit('open-drive');
      hidePopUp();
    }

    function openPhoneMedia() {
      context.emit('handle-open-phone-media', true);
      hidePopUp();
    }

    function openCase() {
      context.emit('open-case');
      hidePopUp();
    }

    function openFileList() {
      context.emit('open-file-list');
      hidePopUp();
    }

    async function uploadFile(event: Event) {
      const fileList: FileList | null = (event.target as HTMLInputElement).files;
      if (fileList) {
        let convertedFile;
        if (fileList[0].type.includes('bmp')) {
          convertedFile = await bmpConvertorToFile(fileList[0]);
        } else {
          // eslint-disable-next-line prefer-destructuring
          convertedFile = fileList[0];
        }
        context.emit('upload-file', convertedFile);
        hidePopUp();
      }
      fileInput.value!.value = '';
    }

    return {
      mainStore,
      isOpen,
      MEDIA_TYPES,
      hidePopUp,
      openTakePhoto,
      openDriveMedia,
      openPhoneMedia,
      openCase,
      openFileList,
      uploadFile,
      setChooserType,
      fileInput,
      CHOOSER_TYPE,
      openCamera,
      openImagePicker,
      openFilePicker,
    };
  },
});
